import { render } from "./EditCommandeFournisseurPage.vue?vue&type=template&id=67467287&ts=true"
import script from "./EditCommandeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./EditCommandeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__